import { render, staticRenderFns } from "./Difficulty.vue?vue&type=template&id=98f3624e&scoped=true&"
import script from "./Difficulty.vue?vue&type=script&lang=js&"
export * from "./Difficulty.vue?vue&type=script&lang=js&"
import style1 from "./Difficulty.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f3624e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
